




























































































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { EventInfo, Fish, FishToImg, Boat } from '@/api/product';
import { Getter } from 'vuex-class';
import { CalFeatureFlags } from '@/api/utils';

@Component
export default class Event extends Vue {
  @Prop(Object) public readonly event!: EventInfo;
  @Prop(String) public readonly type!: string;
  @Getter('product/boatByID') public getBoat!: (id: number) => Boat;
  @Inject() public readonly flags!: CalFeatureFlags;

  public mounted() {
    console.log({
      cancel: this.event.cancelled,
      fish: this.event.fish.length,
      avail: this.event.avail,
      flag: this.flags.showSoldOutOverride,
    });
    console.log((!this.event.cancelled && this.event.fish.length) && (!this.flags.showSoldOutOverride || this.event.avail));
  }

  public get img(): string {
    return process.env.BASE_URL + 'img/' + FishToImg[this.event.fish].img;
  }

  public get height(): number {
    return FishToImg[this.event.fish].height;
  }

  public get width(): number {
    return FishToImg[this.event.fish].width;
  }
}
